"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const user_context_1 = require("../../context/user-context");
const auth_header_1 = require("./auth-header");
const unauth_header_1 = require("./unauth-header");
const star_1 = require("../../icon/star");
exports.Header = (0, react_1.memo)(() => {
    const { userMeta } = (0, user_context_1.useUserMeta)();
    const theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { width: "100%", sx: {
            background: theme.palette.gradient.primary,
            backgroundSize: "400% 400%",
        }, alignItems: "center", spacing: 4, justifyContent: "space-between", paddingX: theme.spacing(4), paddingY: theme.spacing(2), direction: "row", children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 2, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: star_1.StarIcon, sx: { fontSize: theme.spacing(6) } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h4", noWrap: true, color: "primary.contrastText", children: "Reading Zone" }), (0, jsx_runtime_1.jsx)(material_1.SvgIcon, { component: star_1.StarIcon, sx: { fontSize: theme.spacing(6) } })] }), userMeta ? (0, jsx_runtime_1.jsx)(auth_header_1.AuthHeader, { userMeta: userMeta }) : (0, jsx_runtime_1.jsx)(unauth_header_1.UnauthHeader, {})] }));
});
exports.Header.displayName = "Header";
